import React from "react";
import PropTypes from "prop-types";
import { Button } from "shipnow-mercurio";

const DEFAULT_PROPS = {
  onCancel: null,
};

export const CancelButton = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  return (
    <Button icon="cancel" type="text" onClick={attrs.onCancel}>
      Cancelar
    </Button>
  );
};

CancelButton.propTypes = {
  onCancel: PropTypes.func,
};
